import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
    callStatisticDetail: null,
    callStatisticGroup: [],
    callGroupings: {
        callGroup: [
            'hour',
            'day',
            'week',
            'month',
        ],
        callGroupOptionally: [
            'broker_account_login',
            'operator',
            'originator',
            'country',
            'message_type',
            'bulk_id',
            'template_id',
        ],
    },
};


export const callStatistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};